if (!customElements.get('store-locations')) {
  customElements.define(
    'store-locations',
    class StoreLocations extends HTMLElement {
      constructor() {
        super();
        this.mapElement = this.querySelector('.map-wrapper');
        this.locations = this.querySelectorAll('.location-item');

        this.scrollContainer = this.querySelector('.scroll-container');
        this.scrollUpButton = this.querySelector('.scroll-up-button');
        this.scrollDownButton = this.querySelector('.scroll-down-button');

        if (this.scrollUpButton) {
          this.scrollUpButton.addEventListener('click', this.scrollUp.bind(this));
        }
        if (this.scrollDownButton) {
          this.scrollDownButton.addEventListener('click', this.scrollDown.bind(this));
        }
        this.scrollContainer.addEventListener('scroll', debounce(this.setScrollButtons.bind(this), 50));

        this.setScrollButtons();

        if (typeof google === 'undefined' || typeof google.maps === 'undefined') {
          //trigger a custom event on the window object to load the map
          window.addEventListener('googleMapsReady', this.createMap.bind(this));
        } else {
          this.createMap();
        }
      }

      scrollUp() {
        //mirror the scrollDown() logic but in the other direction
        const currentScroll = this.scrollContainer.scrollTop;
        const maxAddedHeight = this.scrollContainer.clientHeight;
        let scrollTo = this.scrollContainer.scrollTop - 100,
          basisLocation = null,
          addedHeight = 0;

        for (let i = this.locations.length - 1; i >= 0; i--) {
          if (basisLocation) {
            if (addedHeight + this.locations[i].offsetHeight < maxAddedHeight) {
              addedHeight += this.locations[i].offsetHeight;
            } else {
              break;
            }
          } else {
            if (this.locations[i].offsetTop < currentScroll) {
              basisLocation = this.locations[i];
              //addedHeight = this.locations[i].offsetHeight;
              scrollTo = this.locations[i].offsetTop;
            }
          }
        }

        scrollTo -= addedHeight;

        if (scrollTo < 0) {
          scrollTo = 0;
        }

        this.scrollContainer.scrollTo({
          top: scrollTo,
          behavior: 'smooth',
        });

        this.setScrollButtons();
      }

      scrollDown() {
        const currentScroll = this.scrollContainer.scrollTop;
        const maxScroll = this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight;
        const maxAddedHeight = this.scrollContainer.clientHeight;
        let scrollTo = this.scrollContainer.scrollTop + 100,
          basisLocation = null,
          addedHeight = 0;
        //find the first location in the list that is out of view from the current scroll position
        for (let i = 0; i < this.locations.length; i++) {
          if (basisLocation) {
            if (addedHeight + this.locations[i].offsetHeight < maxAddedHeight) {
              addedHeight += this.locations[i].offsetHeight;
            } else {
              break;
            }
          } else {
            if (this.locations[i].offsetTop > currentScroll) {
              basisLocation = this.locations[i];
              addedHeight = this.locations[i].offsetHeight;
              scrollTo = this.locations[i].offsetTop;
            }
          }
        }

        scrollTo += addedHeight;

        if (scrollTo > maxScroll) {
          scrollTo = maxScroll;
        }

        this.scrollContainer.scrollTo({
          top: scrollTo,
          behavior: 'smooth',
        });

        this.setScrollButtons();
      }

      setScrollButtons() {
        if (!this.scrollUpButton || !this.scrollDownButton || !this.scrollContainer) {
          console.log('no buttons or container');
          return;
        }
        const currentScroll = this.scrollContainer.scrollTop;
        const maxScroll = this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight;
        //check if we're scrolled within 100 px of the bottom of scroll container
        if (currentScroll > 20) {
          this.scrollUpButton.classList.remove('hidden');
        } else {
          this.scrollUpButton.classList.add('hidden');
        }
        if (currentScroll < maxScroll - 20) {
          this.scrollDownButton.classList.remove('hidden');
        } else {
          this.scrollDownButton.classList.add('hidden');
        }
      }

      async createMap() {
        // The location of Uluru
        const position = { lat: 32.7482319, lng: -97.0479121 };
        const { Map, InfoWindow } = await google.maps.importLibrary('maps');
        const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary('marker');
        const { PlacesService } = await google.maps.importLibrary('places');
        const map = new Map(this.mapElement, {
          zoom: 8,
          center: position,
          mapId: '331ed93739ef0a8',
          styles: [
            {
              featureType: 'poi',
              elementType: 'labels.icon',
              stylers: [{ visibility: 'off' }],
            },
          ],
        });

        const placesService = new PlacesService(map);

        this.map = map;

        this.locations.forEach((location) => {
          const coordinates = {
            lat: parseFloat(location.dataset.lat),
            lng: parseFloat(location.dataset.lng),
          };
          const pin = new PinElement({
            background: '#c93a3c',
            borderColor: '#a12e30',
            glyphColor: '#f4d8d8',
          });
          const placeId = location.dataset.googlePlaceId;
          const lat = location.dataset.lat;
          const lng = location.dataset.lng;
          const placeName = location.dataset.name;

          if (!lat || !lng) {
            placesService.getDetails({ placeId: placeId }, (place, status) => {
              if (status === google.maps.places.PlacesServiceStatus.OK) {
                const marker = new AdvancedMarkerElement({
                  position: place.geometry.location,
                  map: map,
                  content: pin.element,
                  title: place.name,
                  gmpClickable: true,
                });

                const coord = {
                  lat: place.geometry.location.lat(),
                  lng: place.geometry.location.lng(),
                };

                console.log(placeName, coord);

                const button = location.querySelector('button');

                let address = place.formatted_address;

                let directionLink = '';
                if (place.url) {
                  directionLink = `<a target="_blank" href="${place.url}" class="font-bold text-primary-500 hover:text-primary-600 hover:underline">Get Directions</a>`;
                }

                let contactLink = '';
                if (place.formatted_phone_number) {
                  const phoneUrl = place.formatted_phone_number.replace(/[^0-9]/g, '');
                  contactLink = `<a href="tel://${phoneUrl}" class=" text-dark-600 hover:text-primary-600 hover:underline">${place.formatted_phone_number}</a>`;
                }

                const infoWindow = new InfoWindow({
                  name: place.name,
                  content: `
                  <h4 class="font-heading text-xl/tight">APEX Supply Co.</h4>
                  <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${address}</p>
                  <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${contactLink}</p>
                  <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${directionLink}</p>
                `,
                });

                button.addEventListener('click', () => {
                  map.setCenter(place.geometry.location);
                  map.setZoom(17);
                  infoWindow.open(this.map, marker);
                });

                marker.addListener('click', () => {
                  infoWindow.open(this.map, marker);
                });
              }
            });
          } else {
            const placeCoordinates = { lat: parseFloat(lat), lng: parseFloat(lng) };
            const marker = new AdvancedMarkerElement({
              position: placeCoordinates,
              map: map,
              content: pin.element,
              title: placeName,
              gmpClickable: true,
            });
            const button = location.querySelector('button');
            let address = location.dataset.address;
            let directionLink = '';
            if (location.dataset.googleMapsUrl) {
              directionLink = `<a target="_blank" href="${location.dataset.googleMapsUrl}" class="font-bold text-primary-500 hover:text-primary-600 hover:underline">Get Directions</a>`;
            }

            let contactLink = '';
            if (location.dataset.phone) {
              const phoneUrl = location.dataset.phone.replace(/[^0-9]/g, '');
              contactLink = `<a href="tel://${phoneUrl}" class=" text-dark-600 hover:text-primary-600 hover:underline">${location.dataset.phone}</a>`;
            }

            const infoWindow = new InfoWindow({
              name: placeName,
              content: `
                  <h4 class="font-heading text-xl/tight">APEX Supply Co.</h4>
                  <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${address}</p>
                  <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${contactLink}</p>
                  <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${directionLink}</p>
                `,
            });

            button.addEventListener('click', () => {
              map.setCenter(placeCoordinates);
              map.setZoom(17);
              infoWindow.open(this.map, marker);
            });

            marker.addListener('click', () => {
              infoWindow.open(this.map, marker);
            });
          }
        });

        /*const marker = new AdvancedMarkerElement({
            position: coordinates,
            map: map,
            content: pin.element,
            title: location.dataset.name,
            gmpClickable: true,
          });

          const button = location.querySelector('button');

          let address = location.dataset.address;

          if (location.dataset.address2) {
            address += `<br>${location.dataset.address2}`;
          }

          if (location.dataset.city || location.dataset.state || location.dataset.zip) {
            address += `<br>${location.dataset.city}, ${location.dataset.state} ${location.dataset.zip}`;
          }

          let directionLink = '';
          if (location.dataset.googleMapsUrl) {
            directionLink = `<a target="_blank" href="${location.dataset.googleMapsUrl}" class="font-bold text-primary-500 hover:text-primary-600 hover:underline">Get Directions</a>`;
          }

          let contactLink = '';
          if (location.dataset.phone) {
            const phoneUrl = location.dataset.phone.replace(/[^0-9]/g, '');
            contactLink = `<a href="tel://${phoneUrl}" class=" text-dark-600 hover:text-primary-600 hover:underline">${location.dataset.phone}</a>`;
          }

          const infoWindow = new InfoWindow({
            content: `
              <h4 class="font-heading text-xl/tight">${location.dataset.name}</h4>
              <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${address}</p>
              <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${contactLink}</p>
              <p class="text-sm font-normal mt-1.5 text-dark-600 empty:hidden">${directionLink}</p>
            `,
          });

          button.addEventListener('click', () => {
            map.setCenter(coordinates);
            map.setZoom(17);
            infoWindow.open(this.map, marker);
          });

          marker.addListener('click', () => {
            infoWindow.open(this.map, marker);
          });
        });*/
      }
    }
  );
}
